import { ScheduledEmailStatus } from '@dealstack/shared/lib/backendClient';
import type { ScheduledEmailRes } from '@dealstack/shared/lib/backendClient';

export enum ScheduledQueueStatusFilter {
	ALL = 'ALL',
	ACTIVE = 'ACTIVE',
	COMPLETED = 'COMPLETED',
	CANCELLED = 'CANCELLED',
	FAILED = 'FAILED',
}

export const SCHEDULED_QUEUE_STATUS_FILTER_TO_QUERY_STATUS: Record<
	ScheduledQueueStatusFilter,
	ScheduledEmailStatus | undefined
> = {
	[ScheduledQueueStatusFilter.ALL]: undefined,
	[ScheduledQueueStatusFilter.ACTIVE]: ScheduledEmailStatus.ACTIVE,
	[ScheduledQueueStatusFilter.COMPLETED]: ScheduledEmailStatus.COMPLETED,
	[ScheduledQueueStatusFilter.CANCELLED]: ScheduledEmailStatus.CANCELLED,
	[ScheduledQueueStatusFilter.FAILED]: ScheduledEmailStatus.FAILED,
};

export interface RescheduleTarget {
	id: string;
	nextFireAt: string;
}

export type ConfirmAction = 'send-now' | 'cancel' | 'restart';

export interface ConfirmState {
	action: ConfirmAction;
	schedule: ScheduledEmailRes;
}
